import React, { Component } from 'react'

import { PageContainer } from '../../smart-components'

export default class SitemapContainer extends Component {
  render() {
    return (
      <PageContainer>
        <h1>Navigation</h1>
      </PageContainer>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/navigation/index.js